module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/core-js/get-iterator.js
// module id = 340
// module chunks = 0